/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unused-vars */

import {
  Facebook,
  HiristLogo2,
  Instagram,
  LinkedIn,
} from '@jobseeker/lotus/assets/images';
import {HiristAppIconNew} from '@jobseeker/lotus/assets/images/resources/new-logo';
import {ABS_URL, s3Url} from './env';
import {
  aiMl,
  backendDevelopment,
  cyberSecurity,
  dataAnalyticsAndBI,
  dataEngineering,
  devopsSre,
  emergingTechnologies,
  frontendDevelopment,
  fullStack,
  mobileApplication,
  platformEngineeringSreOracle,
  qualityAssurance,
} from '@jobseeker/lotus/assets/icons';
export const CompanyJobsLinkageUrlMapping: any = {
  Product: 'product-jobs',
  'E-Commerce': 'ecommerce-jobs',
  'Fintech/EdTech': 'fintech-edtech-jobs',
};

export const categories = [
  {
    id: 14,
    name: 'AI/ML',
    alias: 'AI/ML',
    icon: aiMl,
    tags: [
      {
        id: 898,
        name: 'Artificial Intelligence',
        alias: 'Artificial Intelligence Jobs',
      },
      {id: 203, name: 'Machine Learning', alias: 'Machine Learning Jobs'},
      {id: 357, name: 'NLP', alias: 'NLP Jobs'},
      {id: 135480, name: 'Generative AI', alias: 'Generative AI Jobs'},
      {
        id: 2916,
        name: 'Predictive Modeling',
        alias: 'Predictive Modeling Jobs',
      },
      {
        id: 198854,
        name: 'Query Segmentation',
        alias: 'Query Segmentation Jobs',
      },
      {id: 198855, name: 'AI Interface', alias: 'AI Interface Jobs'},
      {id: 131480, name: 'LLM', alias: 'LLM Jobs'},
      {id: 2512, name: 'Deep Learning', alias: 'Deep Learning Jobs'},
      {id: 133648, name: 'MLOps', alias: 'MLOps Jobs'},
      {
        id: 198856,
        name: 'Security Architect - AI',
        alias: 'Security Architect - AI Jobs',
      },
      {
        id: 198845,
        name: 'Cloud Architect - ML/AI',
        alias: 'Cloud Architect - ML/AI Jobs',
      },
      {id: 2023, name: 'Data Scientist', alias: 'Data Scientist Jobs'},
      {id: 2174, name: 'Data Modeling', alias: 'Data Modeling Jobs'},
    ],
  },
  {
    id: 7,
    name: 'Data Analytics & BI',
    alias: 'Data Analytics & BI',
    icon: dataAnalyticsAndBI,
    tags: [
      {id: 109, name: 'Analytics', alias: 'Analytics Jobs'},
      {id: 2183, name: 'Data Science', alias: 'Data Science Jobs'},
      {id: 783, name: 'Data Mining', alias: 'Data Mining Jobs'},
      {id: 600, name: 'Tableau', alias: 'Tableau Jobs'},
      {id: 2574, name: 'Power BI', alias: 'Power BI Jobs'},
      {
        id: 15663,
        name: 'Quantitative Analytics',
        alias: 'Quantitative Analytics Jobs',
      },
      {id: 2758, name: 'Data Visualization', alias: 'Data Visualization Jobs'},
      {id: 17730, name: 'Data Analyst', alias: 'Data Analyst Jobs'},
    ],
  },
  {
    id: 15,
    name: 'Data Engineering',
    alias: 'Data Engineering',
    icon: dataEngineering,
    tags: [
      {id: 170423, name: 'Data Engineering', alias: 'Data Engineering Jobs'},
      {id: 111, name: 'Big Data', alias: 'Big Data Jobs'},
      {id: 112, name: 'Hadoop', alias: 'Hadoop Jobs'},
      {id: 801, name: 'Hive', alias: 'Hive Jobs'},
      {id: 4606, name: 'BigQuery', alias: 'BigQuery Jobs'},
      {id: 362, name: 'ETL', alias: 'ETL Jobs'},
    ],
  },
  {
    id: 1,
    name: 'Backend Development',
    alias: 'Backend Development',
    icon: backendDevelopment,
    tags: [
      {id: 9, name: 'Python', alias: 'Python Jobs'},
      {id: 5, name: 'Java', alias: 'Java Jobs'},
      {id: 1756, name: 'GoLang', alias: 'GoLang Jobs'},
      {id: 989, name: 'R', alias: 'R Jobs'},
      {id: 50, name: 'Django', alias: 'Django Jobs'},
      {id: 434, name: 'NodeJs', alias: 'NodeJs Jobs'},
      {id: 46, name: 'Spring', alias: 'Spring Jobs'},
      {id: 47, name: 'Hibernate', alias: 'Hibernate Jobs'},
    ],
  },
  {
    id: 2,
    name: 'Frontend Development',
    alias: 'Frontend Development',
    icon: frontendDevelopment,
    tags: [
      {id: 2043, name: 'ReactJS', alias: 'ReactJS Jobs'},
      {id: 1372, name: 'AngularJS', alias: 'AngularJS Jobs'},
      {id: 26, name: 'Javascript', alias: 'Javascript Jobs'},
      {id: 61, name: 'JQuery', alias: 'JQuery Jobs'},
      {id: 1616, name: 'Bootstrap', alias: 'Bootstrap Jobs'},
      {id: 49, name: 'UI', alias: 'UI Jobs'},
      {id: 2, name: 'UX', alias: 'UX Jobs'},
    ],
  },
  {
    id: 16,
    name: 'Full Stack',
    alias: 'Full Stack',
    icon: fullStack,
    tags: [
      {id: 1612, name: 'Full Stack', alias: 'Full Stack Jobs'},
      {id: 2696, name: 'MERN Stack', alias: 'MERN Stack Jobs'},
      {id: 81, name: 'LAMP', alias: 'LAMP Jobs'},
      {id: 1900, name: 'MEAN', alias: 'MEAN Jobs'},
      {id: 434, name: 'Node.JS', alias: 'Node.JS Jobs'},
      {id: 2043, name: 'React.js', alias: 'React.js Jobs'},
      {id: 2594, name: 'RESTful API', alias: 'RESTful API Jobs'},
    ],
  },
  {
    id: 5,
    name: 'Mobile Applications',
    alias: 'Mobile Applications',
    icon: mobileApplication,
    tags: [
      {id: 63, name: 'iOS', alias: 'iOS Jobs'},
      {id: 56, name: 'Android', alias: 'Android Jobs'},
      {id: 2458, name: 'React Native', alias: 'React Native Jobs'},
      {id: 2258, name: 'Ionic', alias: 'Ionic Jobs'},
      {id: 68, name: 'Phonegap', alias: 'Phonegap Jobs'},
      {id: 1411, name: 'Xamarin', alias: 'Xamarin Jobs'},
      {id: 1006, name: 'OpenGL', alias: 'OpenGL Jobs'},
    ],
  },
  {
    id: 9,
    name: 'Emerging Technologies',
    alias: 'Emerging Technologies',
    icon: emergingTechnologies,
    tags: [
      {id: 2240, name: 'Blockchain', alias: 'Blockchain Jobs'},
      {id: 2633, name: 'Cryptocurrency', alias: 'Cryptocurrency Jobs'},
      {id: 2211, name: 'Augmented Reality', alias: 'Augmented Reality Jobs'},
      {id: 2672, name: 'Virtual Reality', alias: 'Virtual Reality Jobs'},
      {id: 1641, name: 'iOT', alias: 'iOT Jobs'},
    ],
  },
  {
    id: 8,
    name: 'DevOps/SRE',
    alias: 'DevOps / SRE',
    icon: devopsSre,
    tags: [
      {id: 2564, name: 'Site Reliability', alias: 'Site Reliability Jobs'},
      {id: 58, name: 'AWS', alias: 'AWS Jobs'},
      {id: 1239, name: 'AZURE', alias: 'AZURE Jobs'},
      {id: 2266, name: 'Cloud Architect', alias: 'Cloud Architect Jobs'},
      {id: 2631, name: 'Docker', alias: 'Docker Jobs'},
      {id: 2021, name: 'Puppet', alias: 'Puppet Jobs'},
      {id: 1551, name: 'Jenkins', alias: 'Jenkins Jobs'},
      {id: 2020, name: 'Chef', alias: 'Chef Jobs'},
      {id: 2661, name: 'Kubernetes', alias: 'Kubernetes Jobs'},
      {
        id: 3830,
        name: 'Google Cloud Platform',
        alias: 'Google Cloud Platform Jobs',
      },
    ],
  },
  {
    id: 17,
    name: 'CyberSecurity',
    alias: 'CyberSecurity',
    icon: cyberSecurity,
    tags: [
      {id: 2639, name: 'Cyber Security', alias: 'Cyber Security Jobs'},
      {id: 2584, name: 'Cloud Security', alias: 'Cloud Security Jobs'},
      {id: 2514, name: 'CISSP', alias: 'CISSP Jobs'},
      {id: 2630, name: 'CISM', alias: 'CISM Jobs'},
      {
        id: 1851,
        name: 'Information Security',
        alias: 'Information Security Jobs',
      },
      {id: 2623, name: 'Data Security', alias: 'Data Security Jobs'},
      {
        id: 3424,
        name: 'IT Security Strategy',
        alias: 'IT Security Strategy Jobs',
      },
      {id: 2610, name: 'Network Security', alias: 'Network Security Jobs'},
      {id: 1103, name: 'Firewall', alias: 'Firewall Jobs'},
      {id: 452, name: 'IAM', alias: 'IAM Jobs'},
      {id: 1174, name: 'Sailpoint', alias: 'Sailpoint Jobs'},
    ],
  },
  {
    id: 11,
    name: 'Quality Assurance',
    alias: 'Quality Assurance',
    icon: qualityAssurance,
    tags: [
      {
        id: 2489,
        name: 'Performance Testing',
        alias: 'Performance Testing Jobs',
      },
      {
        id: 2842,
        name: 'Application Testing',
        alias: 'Application Testing Jobs',
      },
      {id: 38, name: 'White Box Testing', alias: 'White Box Testing Jobs'},
      {id: 2484, name: 'Security Testing', alias: 'Security Testing Jobs'},
      {id: 2917, name: 'Load Testing', alias: 'Load Testing Jobs'},
      {id: 2056, name: 'Mobile Testing', alias: 'Mobile Testing Jobs'},
      {
        id: 9402,
        name: 'Automation Testing Tools',
        alias: 'Automation Testing Tools Jobs',
      },
      {id: 353, name: 'Selenium', alias: 'Selenium Jobs'},
      {id: 2202, name: 'Test Architect', alias: 'Test Architect Jobs'},
    ],
  },
  {
    id: 6,
    name: 'Platform Engineering/SAP/Oracle',
    alias: 'Platform Engineering / SAP/ Oracle',
    icon: platformEngineeringSreOracle,
    tags: [
      {id: 455, name: 'Pega', alias: 'Pega Jobs'},
      {id: 2234, name: 'RPA', alias: 'RPA Jobs'},
      {id: 178, name: 'ERP', alias: 'ERP Jobs'},
      {id: 195, name: 'SAP FICO', alias: 'SAP FICO Jobs'},
      {id: 446, name: 'CRM', alias: 'CRM Jobs'},
      {id: 2632, name: 'SAP Implementation', alias: 'SAP Implementation Jobs'},
      {
        id: 2905,
        name: 'Techno-Functional Consultant',
        alias: 'Techno-Functional Consultant Jobs',
      },
      {id: 51, name: 'Salesforce', alias: 'Salesforce Jobs'},
      {id: 58309, name: 'Integration Tools', alias: 'Integration Tools Jobs'},
      {id: 268, name: 'Sharepoint', alias: 'Sharepoint Jobs'},
      {id: 6588, name: 'PowerApps', alias: 'PowerApps Jobs'},
      {id: 334, name: 'Oracle Apps', alias: 'Oracle Apps Jobs'},
      {id: 174, name: 'Presales', alias: 'Presales Jobs'},
      {id: 175, name: 'Solution Design', alias: 'Solution Design Jobs'},
      {id: 29, name: 'Solution Architect', alias: 'Solution Architect Jobs'},
      {id: 112953, name: 'LCDP', alias: 'LCDP Jobs'},
      {id: 333, name: 'Mainframe', alias: 'Mainframe Jobs'},
      {id: 379, name: 'Informatica', alias: 'Informatica Jobs'},
    ],
  },
  {
    id: 12,
    name: 'Product Management',
    alias: 'Product Management',
    tags: [
      {id: 6046, name: 'Product Strategy', alias: 'Product Strategy Jobs'},
      {id: 2910, name: 'Product Roadmap', alias: 'Product Roadmap Jobs'},
      {
        id: 14892,
        name: 'Chief Product Officer',
        alias: 'Chief Product Officer Jobs',
      },
      {id: 14796, name: 'UX Strategy', alias: 'UX Strategy Jobs'},
      {id: 2933, name: 'User Story', alias: 'User Story Jobs'},
      {id: 1284, name: 'Wireframe', alias: 'Wireframe Jobs'},
      {id: 3339, name: 'Storyboard', alias: 'Storyboard Jobs'},
      {id: 1571, name: 'Jira', alias: 'Jira Jobs'},
    ],
  },
  {
    id: 13,
    name: 'Business Analysis and Project Management',
    alias: 'Business Analysis and Project Management',
    tags: [
      {id: 30, name: 'Project Management', alias: 'Project Management Jobs'},
      {id: 156, name: 'Business Analyst', alias: 'Business Analyst Jobs'},
      {
        id: 2905,
        name: 'Techno-Functional Consultant',
        alias: 'Techno-Functional Consultant Jobs',
      },
      {id: 98, name: 'Program Management', alias: 'Program Management Jobs'},
      {id: 592, name: 'Agile', alias: 'Agile Jobs'},
      {id: 280, name: 'Scrum', alias: 'Scrum Jobs'},
      {id: 24, name: 'PMP', alias: 'PMP Jobs'},
    ],
  },
  {
    id: 10,
    name: 'UI & Design',
    alias: 'UI & Design',
    tags: [
      {id: 49, name: 'UI', alias: 'UI Jobs'},
      {id: 2, name: 'UX', alias: 'UX Jobs'},
      {id: 536, name: 'Photoshop', alias: 'Photoshop Jobs'},
      {id: 863, name: 'Illustrator', alias: 'Illustrator Jobs'},
      {id: 1728, name: 'Infographics', alias: 'Infographics Jobs'},
      {id: 1000, name: 'CorelDRAW', alias: 'CorelDRAW Jobs'},
      {id: 859, name: 'InDesign', alias: 'InDesign Jobs'},
      {id: 2590, name: 'Sketch', alias: 'Sketch Jobs'},
      {id: 4716, name: 'Figma', alias: 'Figma Jobs'},
      {id: 3238, name: 'Interaction Design', alias: 'Interaction Design Jobs'},
    ],
  },
  {
    id: 4,
    name: 'Semiconductor/VLSI/EDA',
    alias: 'Semiconductor/VLSI/EDA',
    tags: [
      {id: 402, name: 'MATLAB', alias: 'MATLAB Jobs'},
      {id: 191, name: 'Verilog', alias: 'Verilog Jobs'},
      {id: 426, name: 'RTL', alias: 'RTL Jobs'},
      {id: 549, name: 'ASIC', alias: 'ASIC Jobs'},
      {id: 116, name: 'Physical Design', alias: 'Physical Design Jobs'},
      {id: 104, name: 'System Verilog', alias: 'System Verilog Jobs'},
      {id: 197, name: 'VHDL', alias: 'VHDL Jobs'},
      {id: 619, name: 'Board Design', alias: 'Board Design Jobs'},
      {id: 100, name: 'VLSI', alias: 'VLSI Jobs'},
    ],
  },
  {
    id: 3,
    name: 'Others',
    alias: 'Others',
    tags: [
      {id: 794, name: 'IT Operations', alias: 'IT Operations Jobs'},
      {id: 530, name: 'Technical Support', alias: 'Technical Support Jobs'},
      {
        id: 90,
        name: 'System Administration',
        alias: 'System Administration Jobs',
      },
      {id: 2831, name: 'DBMS', alias: 'DBMS Jobs'},
      {id: 66, name: 'DBA', alias: 'DBA Jobs'},
      {id: 39, name: 'IT Infrastructure', alias: 'IT Infrastructure Jobs'},
      {id: 417, name: 'Technical Writing', alias: 'Technical Writing Jobs'},
      {id: 177, name: 'SEO', alias: 'SEO Jobs'},
      {id: 6311, name: 'Network Support', alias: 'Network Support Jobs'},
      {id: 547, name: 'ITIL', alias: 'ITIL Jobs'},
      {id: 939, name: 'Incident Management', alias: 'Incident Management Jobs'},
      {id: 1230, name: 'Change Management', alias: 'Change Management Jobs'},
      {id: 2232, name: 'ITSM', alias: 'ITSM Jobs'},
    ],
  },
];
export const jobColors = [
  '#75ce93',
  '#459bd0',
  '#b4b9d8',
  '#f2998f',
  '#a877e8',
  '#4fb6ac',
];

const Upstox = `Upstox-160X35`;
const Paytm = `Paytm-160X35`;
const Policybazaar = `Policybazaar-160X35`;
const Rapido = `Rapido-160X35`;
const Redbus = `Redbus-160X35`;
const Smartcoin = `Smartcoin-160X35`;
const Snapdeal = `Snapdeal-160X35`;
const Swiggy = `Swiggy-160X35`;
// const Hike = `Hike-160X35`;
const Lendingkart = `Lendingkart-160X35`;
const Makemytrip = `Makemytrip-160X35`;
const Meesho = `Meesho-160X35`;
const Mobikwik = `Mobikwik-160X35`;
const Myntra = `Myntra-160X35`;
const Ola = `Ola-160X35`;
const Oyo = `Oyo-160X35`;
const Amazon = `Amazon-160X35`;
const Bookmyshow = `Bookmyshow-160X35`;
// const Dream11 = `Dream11-160X35`;
// const Firstcry = `Firstcry-160X35`;
const Freecharge = `Freecharge-160X35`;
const Flipkart = `Flipkart-160X35`;
// const GSNgames = `GSNgames-160X35`;
const Onemg = `1mg-160X35`;
const Apple = 'Apple-160X35';
const Uber = 'Uber-160X35';

// Tech Drive Logos

// const bosh = "Bosh";
// const makeMyTrip = "Make-My-Trip";
// const americanExpress = "American-Express";
// const ramsoft = "Ramsoft";
// const stateStreet = "State-Street";
// const cashfree = "Cashfree";
// const oracle = "Oracle";
// const titan = "Titan";
// const moengage = "Moengage";
// const powerschool = "Powerschool";
// const haleon = "Haleon";
// const exxonmobil = "Exxonmobil";
// const miqDigital = "MiQ+digital";
// const mphasis = "Mphasis";

// New Tech Drive Logos

const americanExpress = 'American+Express-150X70';
const bosch = 'Bosch-150X70';
const deloitte = 'Deloitte-150X70';
const deltaAirlines = 'Delta+Airlines-150X70';
const exxonMobil = 'Exxon+Mobil-150X70';
const games247 = 'Games+247-150X70';
const haleon = 'Haleon-150X70';
const shareChat = 'ShareChat-150X70';
const tesco = 'Tesco-150X70';
const wiproTechnologies = 'Wipro+Technologies-150X70';

export const IconTag = [
  {
    CompanyIconTag: Apple,
  },
  {
    CompanyIconTag: Flipkart,
  },
  {
    CompanyIconTag: Uber,
  },
  {
    CompanyIconTag: Paytm,
  },
  {
    CompanyIconTag: Amazon,
  },
  {
    CompanyIconTag: Swiggy,
  },
  {
    CompanyIconTag: Ola,
  },
  {
    CompanyIconTag: Oyo,
  },
  {
    CompanyIconTag: Redbus,
  },
  {
    CompanyIconTag: Makemytrip,
  },
  {
    CompanyIconTag: Myntra,
  },
  {
    CompanyIconTag: Snapdeal,
  },
  {
    CompanyIconTag: Mobikwik,
  },
  // {
  // CompanyIconTag: Hike,
  // },
  {
    CompanyIconTag: Policybazaar,
  },
  {
    CompanyIconTag: Freecharge,
  },
  {
    CompanyIconTag: Bookmyshow,
  },
  // {
  //   CompanyIconTag: Firstcry,
  // },
  {
    CompanyIconTag: Rapido,
  },
  {
    CompanyIconTag: Meesho,
  },
  {
    CompanyIconTag: Smartcoin,
  },
  {
    CompanyIconTag: Upstox,
  },
  {
    CompanyIconTag: Lendingkart,
  },
  {
    CompanyIconTag: Onemg,
  },
  // {
  //   CompanyIconTag: GSNgames,
  // },
  // {
  //   CompanyIconTag: Dream11,
  // },
];

export const TechDriveIconTag = [
  {
    CompanyIconTag: americanExpress,
  },
  {
    CompanyIconTag: bosch,
  },
  {
    CompanyIconTag: deloitte,
  },
  {
    CompanyIconTag: deltaAirlines,
  },
  {
    CompanyIconTag: exxonMobil,
  },
  {
    CompanyIconTag: games247,
  },
  {
    CompanyIconTag: haleon,
  },
  {
    CompanyIconTag: shareChat,
  },
  {
    CompanyIconTag: tesco,
  },
  {
    CompanyIconTag: wiproTechnologies,
  },
];
export const words = [
  'Machine Learning',
  'iOS Developer',
  'Android Developer',
  'ReactJS Developer',
  'Data Scientist',
  'AngularJS Developer',
  'AWS Engineer',
  'Python Developer',
  'Blockchain Engineer',
  'DevOps Engineer',
  'Artificial Intelligence',
  'iOT Engineer',
  'UX Designer',
  'Augmented Reality',
  'Java Developer',
  'Virtual Reality',
  'Golang Developer',
  'Ruby on Rails',
  'NodeJS Developer',
  'Python/Django',
  'Data Analytics',
  'Big Data Engineer',
  'NLP',
  'Project Management',
];
export const footerCityJobsData = [
  {
    colCount: 7,
    heading: 'Jobs by location',
    data: [
      {link: `${ABS_URL}/it-jobs-in-bangalore`, text: 'Jobs in Bangalore'},
      {link: `${ABS_URL}/it-jobs-in-delhi-ncr`, text: 'Jobs in Delhi/NCR'},
      {link: `${ABS_URL}/it-jobs-in-noida`, text: 'Jobs in Noida'},
      {
        link: `${ABS_URL}/it-jobs-in-gurgaon-gurugram`,
        text: 'Jobs in Gurgaon/Gurugram',
      },
      {link: `${ABS_URL}/it-jobs-in-mumbai`, text: 'Jobs in Mumbai'},
      {link: `${ABS_URL}/it-jobs-in-pune`, text: 'Jobs in Pune'},
      {link: `${ABS_URL}/it-jobs-in-hyderabad`, text: 'Jobs in Hyderabad'},
      {link: `${ABS_URL}/it-jobs-in-chennai`, text: 'Jobs in Chennai'},
      {
        link: `${ABS_URL}/it-jobs-in-coimbatore`,
        text: 'Jobs in Coimbatore',
      },
      {link: `${ABS_URL}/it-jobs-in-kolkata`, text: 'Jobs in Kolkata'},
      {link: `${ABS_URL}/it-jobs-in-indore`, text: 'Jobs in Indore'},
      {link: `${ABS_URL}/it-jobs-in-jaipur`, text: 'Jobs in Jaipur'},
      {
        link: `${ABS_URL}/it-jobs-in-chandigarh`,
        text: 'Jobs in Chandigarh',
      },
    ],
  },
  {
    colCount: 7,
    heading: 'Jobs by Domain',
    data: [
      {
        link: `${ABS_URL}/product-jobs`,
        text: 'Jobs from Product Companies',
      },
      {
        link: `${ABS_URL}/ecommerce-jobs`,
        text: 'Jobs from E-commerce Companies',
      },
      {
        link: `${ABS_URL}/fintech-edtech-jobs`,
        text: 'Jobs from Fin-tech Companies',
      },
    ],
  },
  {
    colCount: 7,
    heading: 'Jobs by Categories',
    styleClass: 'city-list-text',
    data: [
      {
        link: ABS_URL + '/c/backend-development-jobs',
        text: 'Jobs in Backend Development',
      },
      {
        link: ABS_URL + '/c/frontend-development-jobs',
        text: 'Jobs in Frontend Development',
      },
      {
        link: ABS_URL + '/c/data-analytics-bi-jobs',
        text: 'Jobs in Data Analytics & BI',
      },
      {
        link: ABS_URL + '/c/mobile-applications-jobs',
        text: 'Jobs in Mobile Application',
      },
      {
        link: ABS_URL + '/c/devops-sre-jobs',
        text: 'Jobs in Devops / SRE',
      },
      {
        link: ABS_URL + '/c/emerging-technologies-jobs',
        text: 'Jobs in Emerging Technologies',
      },
    ],
  },
];

export const socialData = [
  {
    link: ABS_URL + '/',
    img: {
      src: 'https://hirist-assets.s3.ap-south-1.amazonaws.com/hirist-tech-logo-new.webp',
      alt: 'HIRIST.TECH',
      class: 'logo-img-list',
      height: 35,
      width: 135,
    },
  },
];

export const socialLinks = [
  {
    link: 'https://www.linkedin.com/company/hirist-com/',
    src: LinkedIn,
    alt: 'linkedIn',
  },
  {
    link: 'https://www.facebook.com/hirist.jobs',
    src: Facebook,
    alt: 'facebook',
  },
  {
    link: 'https://www.instagram.com/hirist.tech/',
    src: Instagram,
    alt: 'instagram',
  },
];
